import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "7deea58c-bae0-4633-ad88-272ba1dde849", content: "MUSHRA (ITU-R BS.1534)", options: {} },
  { id: "3d581c7e-897c-46be-a68c-a3ff475b1d0e", content: "Mean Opinion Score (MOS)", options: {} },
  { id: "db735b11-22b5-4030-be60-33824a4ac645", content: "Absolute Category Rating (ACR)", options: {} },
  { id: "5c100c4b-a43c-4d47-ad77-9aaf64f01266", content: "ITU-R BS.1116", options: {} },
];

export const task: Task = {
  id: "05017994-cca6-40d6-92f6-2531929bbe09",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["3d581c7e-897c-46be-a68c-a3ff475b1d0e", "db735b11-22b5-4030-be60-33824a4ac645"],
};
